import { IconBrandDatabricks, IconServerBolt } from '@tabler/icons-react';

const deployments = {
    id: 'deployments',
    title: 'DEPLOYMENTS',
    icon: IconBrandDatabricks,
    type: 'group',
    children: [
        {
            id: 'deployments-list',
            title: 'DEPLOYMENTS',
            type: 'item',
            url: '/deployments',
            icon: IconBrandDatabricks,
            breadcrumbs: false,
            tags: [
                'deployment',
                'deployments',
                'client deployment',
                'client setup',
                'organisation',
                'organization',
                'company',
                'tenant',
                'tenant setup',
                'client details',
                'client account',
                'client info',
                'settings',
                'system setup',
                'configuration',
                'config',
                'environment',
                'instance',
                'domain',
                'subdomain',
                'url',
                'hosting',
                'installation',
                'launch',
                'project setup',
                'account setup',
                'management',
                'admin',
                'client management'
            ]
        },
        {
            id: 'deployment-requests',
            title: 'DEPLOYMENT REQUESTS',
            type: 'item',
            url: '/deployment-requests',
            icon: IconServerBolt,
            breadcrumbs: false,
            tags: [
                'deployment request',
                'deployment requests',
                'client request',
                'new deployment',
                'new client request',
                'pending deployment',
                'pending request',
                'awaiting approval',
                'approval',
                'review',
                'review request',
                'request details',
                'request form',
                'submitted request',
                'setup request',
                'client onboarding',
                'onboarding request',
                'account request',
                'organisation request',
                'organization request',
                'request management',
                'client setup request',
                'request queue'
            ]
        }
    ]
};

export default deployments;
